import React from 'react';
import { Modal } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/modules/modal.less';

export default Modal;
